var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgReactivateConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.812,
    viewBox: "0 0 90.161 71.812"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "KPMG Reactivate Confirm"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.58 2.001a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H4.006a4 4 0 01-3.465-6z",
    "data-name": "Path 948",
    fill: "#43b02a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.58 44.602h3.14l1.142-3.887 2.649 10.191L43.273 32l2.911 24.918 3.118-17.172 2.1 9.066 2.043-4.211h2.9",
    "data-name": "ICN_Modal Confirmare Reactiveaza_Enabled",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }))));
}

export default SvgKpmgReactivateConfirm;